<template>
  <van-popup
    v-model:show="visible"
    round
    position="center"
    :style="{ width: '312px' }"
  >
    <div class="outside_box">
      <div class="login-dialog">
        <h3 class="title">{{ $t('me.you_are_not_logged_in') }}</h3>
        <p class="desc">
          {{ $t('me.top_up_coins') }}
        </p>
        <!--        <div class="login_tips">-->
        <!--          <img src="~/assets/images/me/icon-me-coin.svg" alt="">-->
        <!--          <p>{{ $t('reader.first_login_bonus') }} <span style="font-weight: 600">30</span> {{-->
        <!--              $t('reader.coins_lower')-->
        <!--            }}</p>-->
        <!--        </div>-->

        <van-button
          :loading="isLogging"
          type="primary"
          block
          round
          class="facebook-btn"
          @click="handleFacebookLogin"
        >
          <template #icon>
            <img
              src="~/assets/images/me/icon-me-fb-2.svg"
              class="fb-icon"
              alt=""
            />
            <!--            <div class="bredge_icon">-->
            <!--              <img src="~/assets/images/reader/icon-reader-bredge-bg.svg" alt="">-->
            <!--              <p>+ 30 {{ $t('reader.coins') }}</p>-->
            <!--            </div>-->
          </template>
          {{ $t('me.sign_in_with_facebook') }}
        </van-button>

        <p class="agreement">
          {{ $t('me.by_logging_in') }}
          <span @click="handleClick('/third-party/user_agreement')">{{
            $t('me.user_agreement')
          }}</span>
          {{ $t('me.and') }}
          <span @click="handleClick('/third-party/privacy')">{{
            $t('me.privacy_policy')
          }}</span
          >.
        </p>
      </div>
      <img
        class="icon_c"
        src="~/assets/images/reader/icon-reader-popup-close.png"
        alt=""
        @click="close"
      />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
declare const FB: any
import { ref } from 'vue'
import { showToast } from 'vant'
import eventBus from "../../utils/eventBus";
const emits = defineEmits(['updateUserInfo'])
const visible = ref(false)
const isLogging = ref(false)
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const props = defineProps({
  chapterId: {
    type: String,
    default: ''
  }
})

const handleClick = (url: string) => {
  console.log(route, router)
  const isReader = route.path === '/reader'
  const returnPath = isReader
    ? `${route.path}?id=${route.query.id}&chapter_id=${props.chapterId}`
    : route.fullPath
  router.push({
    path: url,
    query: {
      returnPath: encodeURIComponent(returnPath)
    }
  })
}
// 打开弹窗的方法（父组件调用）
const open = () => {
  visible.value = true
}
const close = () => {
  visible.value = false
  isLogging.value = false
}

const handleFacebookLogin = () => {
  console.log('Facebook 登录逻辑')
  isLogging.value = true
  try {
    FB.login(
      (response: any) => {
        if (response.authResponse) {
          console.log('登录成功', response.authResponse)
          handleAuthorize(response.authResponse.accessToken)
          isLogging.value = false
        } else {
          console.log('用户取消或登录失败')
          isLogging.value = false
          visible.value = false
          showToast(t('me.facebook_login_canceled'))
        }
      },
      { scope: 'public_profile,email' }
    )
  } catch (e) {
    console.log(e)
  }
}

// 授权
const handleAuthorize = async (accessToken: string) => {
  // 这里可以把 accessToken 传给后端做验证 & 换取用户信息
  const body = {
    provider: 'facebook',
    identity_token: accessToken || '',
    signup_source: window.location.pathname.includes('/ads') ? 2 : 1,
    monetization: ''
  }
  try {
    const res = (await useClientFetch('/api/me/auth-oauth', {
      method: 'POST',
      body
    })) as any
    console.log('授权原始数据', res)
    const realData = res.data.value
    console.log('授权登录', realData)
    if (realData.code === 0) {
      showToast(t('me.facebook_login_success'))
      //   更新cookie信息
      const loginInfoCookie = useCookie('login_info', {
        path: '/', // 作用于全站
        maxAge: 60 * 60 * 24 * 400 // 7 天
      })
      // loginInfoCookie.value = realData.data// 假设后端返回 token 和用户信息都在 data
      // localStorage.setItem('login_info', JSON.stringify(realData.data))
      //await getUserInfo()
      const access_token = useCookie('access_token')
      access_token.value = realData.data.access_token
      localStorage.setItem('access_token', realData.data.access_token)
      // 更新用户信息
      emits('updateUserInfo', realData.data)
      eventBus.emit('hide_login_entry')
    } else {
      showToast(t('me.facebook_login_failed'))
    }
  } catch (e) {
    showToast(t('me.facebook_login_failed'))
  } finally {
    close()
  }
}

// 获取用户信息
const getUserInfo = async () => {
  try {
    const res = await clientFetch('/api/me/get-user-info')
    const loginInfo = useCookie('login_info', { path: '/' })
    if (res.code === 0) {
      if (process.client) {
        localStorage.setItem('login_info', JSON.stringify(res.data))
      }
      // 直接更新 cookie
      loginInfo.value = res.data
    }
  } catch (e) {
    console.error('getUserInfo error', e)
  }
}

defineExpose({ open, close })
</script>

<style scoped>
.van-popup {
  background: transparent;
}

.outside_box {
  position: relative;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 21px;
  font-family: 'SFPro', 'SFPro';

  .login-dialog {
    text-align: center;
    background: url('~/assets/images/me/icon-me-login-bg.svg') no-repeat center / cover,
      #ffffff;
    padding: 21px;
    position: relative;
    border-radius: 21px;
  }

  .icon_c {
    width: 25px;
    height: 25px;
  }
}

.title {
  margin-bottom: 10px;
  font-family: 'SFPro', 'SFPro';
  font-weight: 600;
  font-size: 18px;
  color: #222222;
  text-align: center;
  font-style: normal;
}

.desc {
  margin-bottom: 23px;
  font-family: 'SFPro', 'SFPro';
  font-weight: 400;
  font-size: 14px;
  color: #858c99;
  line-height: 16px;
  text-align: center;
  font-style: normal;
}

.login_tips {
  width: 217px;
  padding: 5px 14px;
  background: #fff2dc;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fe6840;
  font-family: 'SFPro', 'SFPro';
  gap: 4px;
  margin: 0 auto 21px;

  img {
    width: 12px;
    height: 12px;
  }
}

.facebook-btn {
  background: #1877f2;
  border: none;
  height: 41px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: 'SFPro', 'SFPro';
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 19px;
  text-align: right;
  font-style: normal;
  position: relative;

  .bredge_icon {
    position: absolute;
    width: 64px;
    height: 27px;
    top: -9px;
    right: 0;

    img {
      width: 100%;
      height: 100%;
    }

    p {
      width: 100%;
      height: 13px;
      font-family: Ubuntu, Ubuntu;
      font-weight: 500;
      font-size: 11px;
      color: #ffffff;
      line-height: 13px;
      text-align: center;
      font-style: normal;
      position: absolute;
      top: 3px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.fb-icon {
  width: 25px;
  height: 25px;
  transform: translateY(2px);
}

.agreement {
  font-size: 12px;
  color: #999;
  line-height: 1.4;
  span {
    color: #1877f2;
    text-decoration: underline;
  }
}

.agreement a {
  color: #1877f2;
  text-decoration: underline;
}
</style>
